import { BasicLayout, OrientationMap, Orientor } from '@1x2network/layout'
import { ContainerSpecification, ScalingText, ScalingTextSpecification } from '@1x2network/pixi_assets'
import { Page, SplashComponent } from '@1x2network/pixi_splash'
import { CollectorAnimationLoop, CollectorAnimationLoopSpecification } from './loops/CollectorAnimationLoop'
import { HoldAndWinLoop, HoldAndWinLoopSpecification } from './loops/HoldAndWinLoop'
import { AntebetAnimationLoop, AntebetLoopSpecification } from './loops/AntebetAnimationLoop'

/**
 * A single page in the splash screen. Train Strike only has 1 page, so this is all of the splash contents.
 * @author Adam Drake - <adam.drake@1x2network.com>
 * @version 1.0.0
 */
export class SplashPage extends Page<AnySplashPageSpec> {
    private layout: BasicLayout
    private hawText: Orientor<ScalingText>
    private collectorText: Orientor<ScalingText>
    private antebetText?: Orientor<ScalingText>

    constructor(options: { spec: AnySplashPageSpec; layout: BasicLayout }) {
        super({ spec: options.spec })

        this.layout = options.layout
        const spec = this.specification.sections

        this.collectorText = new Orientor({
            layout: this.layout,
            spec: spec.haw.text,
            create: (spec: ScalingTextSpecification) => new ScalingText({ spec, parent: this }),
            onOrient: (active, inactive) => {
                active.visible = true
                inactive.visible = false
            },
        })

        this.hawText = new Orientor({
            layout: this.layout,
            spec: spec.collector.text,
            create: (spec: ScalingTextSpecification) => new ScalingText({ spec, parent: this }),
            onOrient: (active, inactive) => {
                active.visible = true
                inactive.visible = false
            },
        })

        if ('antebet' in spec) {
            this.antebetText = new Orientor({
                layout: this.layout,
                spec: spec.antebet.text,
                create: (spec: ScalingTextSpecification) => new ScalingText({ spec, parent: this }),
                onOrient: (active, inactive) => {
                    active.visible = true
                    inactive.visible = false
                },
            })
        }

        const components: SplashComponent[] = [
            new CollectorAnimationLoop({ parent: this, layout: this.layout, spec: spec.collector.loop }),
            new HoldAndWinLoop({ parent: this, layout: this.layout, spec: spec.haw.loop }),
        ]

        if ('antebet' in spec) {
            components.push(new AntebetAnimationLoop({ parent: this, layout: this.layout, spec: spec.antebet.loop }))
        }
        this.addComponents(...components)
    }
}

export type AnySplashPageSpec = SplashPageSpec | AntebetSplashPageSpec

export interface SplashPageSpec extends ContainerSpecification {
    sections: {
        haw: {
            loop: HoldAndWinLoopSpecification
            text: OrientationMap<ScalingTextSpecification>
        }
        collector: {
            loop: CollectorAnimationLoopSpecification
            text: OrientationMap<ScalingTextSpecification>
        }
    }
}

export interface AntebetSplashPageSpec extends ContainerSpecification {
    sections: {
        haw: {
            loop: HoldAndWinLoopSpecification
            text: OrientationMap<ScalingTextSpecification>
        }
        collector: {
            loop: CollectorAnimationLoopSpecification
            text: OrientationMap<ScalingTextSpecification>
        }
        antebet: {
            loop: AntebetLoopSpecification
            text: OrientationMap<ScalingTextSpecification>
        }
    }
}
